<template>
  <ul
    v-if="locationsStore.loading"
    role="list"
    class="absolute md:static md:gap gap-x-2 divide-solid divide-y-1 divide-gray-900 h-full w-full overflow-scroll z-10"
  >
    <li
      v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
      :key="i"
      class="border-solid border-b border-0.5px border-gray-900"
    >
      <div
        class="px-4 lg:px-6 pt-3 pb-2 flex items-center justify-between gap-x-6"
      >
        <div class="h-6 w-24 bg-gray-900 rounded animate-pulse"></div>
      </div>
      <div class="px-4 lg:px-6 mb-2 flex flex-none items-center gap-x-4">
        <div class="h-3 w-24 bg-gray-900 rounded-sm animate-pulse"></div>
        <div class="h-3 w-24 bg-gray-900 rounded-sm animate-pulse"></div>
      </div>
    </li>
  </ul>

  <div
    v-else-if="locationsStore.noResultsFromSearch"
    class="mt-2 md:mt-8 px-6 md:px-8 flex flex-col justify-center w-full"
  >
    <div class="flex justify-center">
      <p style="font-size: 5rem">🧐 🗺️</p>
    </div>
    <div>
      <h2 class="text-white text-center text-lg font-semithin pb-2">
        No Indoor Golf Facilities Located
      </h2>
      <p class="text-gray-400 leading-5 text-center">
        The search did not return any indoor facilities.
      </p>
      <p class="text-gray-400 leading-5 text-center">
        Refine the search query or map boundaries.
      </p>
      <p class="text-gray-400 leading-5 text-center pt-2">
        Are you an indoor facility owner?
        <a
          class="text-green-300 underline"
          href="https://pinseekergame.com/indoor-golf-venues/?utm=venue_locator_map"
          target="_blank"
          >Click here</a
        >
        to be added to the map!
      </p>
    </div>
  </div>

  <ul
    v-else
    role="list"
    class="absolute md:static md:gap gap-x-2 divide-solid divide-y-1 divide-gray-900 h-full w-full overflow-scroll z-10"
  >
    <li
      v-for="location in locationsStore.locations"
      :key="location.id"
      @click="focusOnClickedVenue(location)"
      :class="{
        'bg-gray-800':
          locationsStore.focusedLocation &&
          locationsStore.focusedLocation.id === location.id,
      }"
      class="border-solid border-b border-0.5px border-gray-900 cursor-pointer"
    >
      <div
        class="px-4 lg:px-6 pt-3 pb-2 flex items-center justify-between gap-x-6 hover:bg-gray-900"
      >
        <div class="min-w-0">
          <div class="flex items-start gap-x-3">
            <p
              class="text-md xl:text-lg pb-1 text-white whitespace-nowrap truncate"
            >
              {{ location.name }}
            </p>
            <p
              v-if="location.official_partner"
              class="rounded whitespace-nowrap px-1.5 py-0.5 pb-0 leading-5 text-xs font-medium text-green-800 bg-green-300"
            >
              Official Partner
            </p>
            <p
              v-else-if="location.verified"
              class="rounded whitespace-nowrap px-1.5 py-0.5 pb-0 leading-5 text-xs font-medium text-black bg-white"
            >
              Verified Location
            </p>
          </div>
          <div class="flex items-center gap-x-2 text-xs text-gray-500">
            <p v-if="location.distance" class="text-sm pb-0 whitespace-nowrap">
              {{ location.distance.toFixed(2) }} miles Away
            </p>
          </div>
        </div>
        <div class="flex flex-none items-center gap-x-4">
          <div class="relative flex-none">
            <button
              type="button"
              class="-m-2.5 block p-2.5 pt-1.5 text-gray-800"
              id="options-menu-0-button"
              aria-expanded="false"
              aria-haspopup="true"
            >
              <span class="sr-only">Open options</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </li>

    <li>
      <div class="px-4 lg:px-6 pt-3 pb-2">
        <p class="text-white text-xs leading-5 text-center">
          Are you an indoor facility owner?
          <a
            class="text-green-300 underline"
            href="https://pinseekergame.com/indoor-golf-venues/?utm=venue_locator_map"
            target="_blank"
            >Click here</a
          >
          to be added to the map!
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import { useLocationsStore } from "../stores/locationsStore";
import { useLocationTermStore } from "../stores/locationTermStore";

export default {
  setup() {
    const locationsStore = useLocationsStore();
    const locationTermStore = useLocationTermStore();

    return { locationsStore, locationTermStore };
  },

  methods: {
    focusOnClickedVenue(location) {
      this.locationsStore.focusedLocation = location;
      this.locationTermStore.coords = {
        latitude: location.latitude,
        longitude: location.longitude,
      };
    },
  },
};
</script>
